<template>
  <footer class="e-dialog__footer">
    <el-button
      v-if="data.outgoing"
      class="e-btn--delete e-btn--ghost"
      @click="$emit('delete-item')"
      :aria-label="$t('system.delete')"
    >
      <IconTrash role="presentation" />
      <span class="e-mobile-hidden">
        {{ $t('system.delete') }}
      </span>
    </el-button>

    <el-button-group v-if="!data.outgoing && (editorEnabled || sendDisabled)">
      <el-button
        type="secondary"
        class="e-btn--answer e-btn e-btn--thin"
        :disabled="sendDisabled"
        @click="$emit('reply', '')"
      >
        <span class="e-mobile-hidden">
          {{ $t('system.toThisMessage') }}
        </span>
        {{ $t('system.answer') }}
        <IconReply role="presentation" />
      </el-button>

      <el-dropdown
        v-if="!sendDisabled"
        trigger="click"
        class="el-button el-button--secondary e-btn--answer-context"
        @command="onQuickReply"
        :disabled="sendDisabled"
      >
        <span class="el-dropdown-link">
          <IconContext :aria-label="$t('aria.dialog.quickReply')" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="done">
            {{ $t('messages.quickReply.doneTitle') }}
          </el-dropdown-item>
          <el-dropdown-item command="later">
            {{ $t('messages.quickReply.laterTitle') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-button-group>
  </footer>
</template>

<script>
// Icons
import IconReply from 'assets/icons/reply.svg'
import IconContext from 'assets/icons/context.svg'
import IconTrash from 'assets/icons/trashcan.svg'

export default {
  name: 'DialogItemFooter',
  components: {
    IconReply,
    IconContext,
    IconTrash
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    editorEnabled: {
      type: Boolean,
      default: false
    },
    sendDisabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onQuickReply(command) {
      let body = ''
      switch (command) {
        case 'done':
          body = this.$t('messages.quickReply.done')
          break
        case 'later':
          body = this.$t('messages.quickReply.later')
          break
      }
      this.$emit('reply', body)
    }
  }
}
</script>
